module.exports = __webpack_public_path__ + "img/BI_1.bfbc8570.png";